import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const NoDomiciliadoRazonSocialFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='No domiciliado - Razon Social' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='noDomiciliadoRazonSocial'>
          {({ field }) => <Form.InputText {...field} id='input-noDomiciliadoRazonSocial' isInvalid={iError && iTouched} disabled={fIsSubmitting} />}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NoDomiciliadoRazonSocialFormGroup)
